import React from 'react';
import { Box, Grid, Typography, CircularProgress, IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { PresentationStateChip } from '../../../Presentaciones/components/PresentationStateChip';
import { PRESENTATION_STATE } from '../../../Presentaciones/consts';
import { useTranslation } from 'react-i18next';

interface RGRLSectionProps {
    rgrlPresentaciones: any[];
    loadingPresentaciones: boolean;
    allPresentationsCancelled: boolean;
    handleOpenDialogRGRL: () => void;
    handleCardClickRGRL: (id: number, nombre: string) => void;
    confirmCancelPresentation: (id: number) => void;
    handleEditRGRL: (presentacion: any) => void;
}

const RGRLSection: React.FC<RGRLSectionProps> = ({
    rgrlPresentaciones,
    loadingPresentaciones,
    allPresentationsCancelled,
    handleOpenDialogRGRL,
    handleCardClickRGRL,
    confirmCancelPresentation,
    handleEditRGRL
}) => {
    const { t } = useTranslation('visitas');

    if (loadingPresentaciones) {
        return (
            <Box display="flex" alignItems="center" gap={6}>
                <CircularProgress size={24} />
            </Box>
        );
    }

    if (rgrlPresentaciones.length === 0 || allPresentationsCancelled) {
        return (
            <Box
                display="grid"
                gridTemplateColumns="20% 60% 20%"
                alignItems="center"
                gap={2}
                sx={{
                    borderBottom: '1px solid #ccc'
                }}
            >
                <Typography>RGRL</Typography>
                <Box>
                    <PresentationStateChip presentationState={PRESENTATION_STATE.PENDIENTE_RGRL} />
                </Box>
                <Box display="flex">
                    <IconButton onClick={handleOpenDialogRGRL}>
                        <EditIcon />
                    </IconButton>
                </Box>
            </Box>
        );
    }

    return (
        <Box display="flex" width="100%" flexDirection="column" gap={2}>
            {rgrlPresentaciones
                .filter((p) => p.idEstado !== 6)
                .map((p) => {
                    const showIcon = ![2, 3, 4, 5].includes(p.idEstado);

                    return (
                        <Box
                            key={p.id}
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                            width="100%"
                            sx={{
                                borderBottom: '1px solid #ccc',
                                padding: '6px 4px'
                            }}
                        >
                            <Box display="flex" alignItems="center" gap={6}>
                                <Typography>RGRL</Typography>
                                <PresentationStateChip presentationState={p.idEstado} />
                            </Box>

                            <Box display="flex" gap={1}>
                                {p.idEstado === PRESENTATION_STATE.BORRADOR ? (
                                    <IconButton onClick={() => handleEditRGRL(p)}>
                                        <EditIcon />
                                    </IconButton>
                                ) : (
                                    showIcon && (
                                        <IconButton
                                            onClick={() =>
                                                handleCardClickRGRL(p.tipo.id, p.tipo.nombre)
                                            }
                                        >
                                            <EditIcon />
                                        </IconButton>
                                    )
                                )}
                                <IconButton onClick={() => confirmCancelPresentation(p.id)}>
                                    <DeleteIcon />
                                </IconButton>
                            </Box>
                        </Box>
                    );
                })}
        </Box>
    );
};

export default RGRLSection;
